/* DEPRECATED (lms-web): Common string formatting functions */

export function thousandSeparated(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0'); // non-breaking space (U+00A0)
}
